export default "__VITE_ASSET__CbIDBrmB__"